import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import { CampaignCategory } from "pages/dealScreener/Email/constants";
import { People, FilterList, Email, Send } from "@material-ui/icons";
import { MaterialIcon } from "@loanbossinc/component-library";
import styled from "styled-components/macro";
import UnselectedChecklistIcon from "lib/images/checklist.svg";
import SelectedChecklistIcon from "lib/images/checklist_selected.svg";

import { StyledIcon } from "./";

const StyledStepper = styled(Stepper)`&& {
  width: 100%;
  background-color: #FAFAFA;
  && > div > span > span > span {
    font-family: Work Sans;
  }
}`;

const StyledStep = styled(Step)`&& {
  // Connecting line between steps
  && > div > span {
    border-color: #DADCE0;
  }

  // Icon itself
  && > span > span > div {
    color: ${({ isActive, disabled, completed }) => determineIconColor({ isActive, disabled, completed })};
    background-color: ${({ isActive }) => (isActive ? "#005AA9" : "#FFFFFF")};
    border-color: #DADCE0;
  }

  // Text beneath each step's icon
  && > span > span > span {
    color: ${({ isActive }) => (isActive ? "#005AA9" : "#5F6368")};
    font-size: 14px;
    font-weight: 400;
  }

  pointer-events: ${({ disabled }) => (disabled ? "none" : "")};
}`;

const StyledChecklistIcon = styled.img`&&& {
  width: 24px;
  height: 24px;
}`;

const determineIconColor = ({ isActive, disabled, completed }) => {
  if (isActive) {
    return "#FFFFFF";
  }

  if (disabled) {
    return "#C4C4C4";
  }

  return "#0F9AD6";
};

const PortfolioIcons = [
  <People key="peopleIcon" />,
  <Email key="emailIcon" />,
  <Send key="sendIcon" />
];

const DealIcons = ({ reviewAndSendIsActive = false }) => [
  <FilterList key="filter_list_icon" />,
  <MaterialIcon iconName="mark_email_read" />,
  <StyledChecklistIcon
    key="checklist_icon"
    src={reviewAndSendIsActive ? SelectedChecklistIcon : UnselectedChecklistIcon}
    alt="checklist_icon" />,
  <People key="people_icon" />
];

const EdcProgressStepper = ({ activeStep, setActiveStep, campaignSteps = [], campaignCategory }) => {
  const reviewAndSendStep = 2;
  const [icons, setIcons] = useState([]);

  useEffect(() => {
    if (campaignCategory === CampaignCategory.PORTFOLIO.id) {
      setIcons(PortfolioIcons);
    }
    if (campaignCategory === CampaignCategory.DEAL.id) {
      if (activeStep === reviewAndSendStep) {
        setIcons(DealIcons({ reviewAndSendIsActive: true }));
      } else {
        setIcons(DealIcons({ reviewAndSendIsActive: false }));
      }
    }
  }, [campaignCategory, activeStep]);

  return (
    <StyledStepper activeStep={activeStep} alternativeLabel>
      {campaignSteps?.map(({ isDisabled, label, id }, idx) => (
        <StyledStep
          disabled={isDisabled}
          key={label}
          onClick={() => setActiveStep(id)}
          isActive={activeStep === idx}
        >
          <StepLabel icon={<StyledIcon icons={icons} activeStep={activeStep} idx={idx} />}>
            {label}
          </StepLabel>
        </StyledStep>
      ))}
    </StyledStepper>
  );
};

export default EdcProgressStepper;
